import FilterSidebar from '@components/FilterSidebar/FilterSidebar';
import React, { FunctionComponent, useEffect } from 'react';
import css from './PromotionRoute.module.less';
import PromotionSelector from '@components/PromotionSelector/PromotionSelector';
import { PromotionActivityList, PromotionActivityEditModal } from '@pages/PromotionPage';
import * as postSelector from '@stores/postSelector';
import modals, { IModalsState } from '@stores/modals';
import { useStore } from 'effector-react';
import PromoFilter from '@components/PromotionActivityFilters';

const PromotionRoute: FunctionComponent<unknown> = () => {
  const {
    visibleState: { activity: visible },
    data,
  } = useStore<IModalsState<any>>(modals);

  useEffect(() => {
    postSelector.reset();
  }, [visible]);

  return (
    <div className={css.root}>
      <FilterSidebar className={css.selector}>
        <PromotionSelector />
        <PromoFilter />
      </FilterSidebar>
      <div className={css.list}>
        <PromotionActivityList />
      </div>
      {visible ? <PromotionActivityEditModal data={data} /> : null}
    </div>
  );
};

export default PromotionRoute;
